import React, { useState, useEffect } from 'react';
import { OptionalState } from '../../utils/ReactHelper';
import Logger from '../../../common/utils/Logger';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Container from 'react-bootstrap/Container';

import HomeHeader from './HomeHeader';
import '../css/Home.css';
import Linker from '../../library/Linker';

type Props = {
    linker: Linker;
};

type State = {
};

const StateDefault: State = {
};

const Home = (props: Props) => {

    const [state, setState] = useState(StateDefault);

    const updateState = (updates: Partial<State>) => {
        setState(OptionalState(state, updates));
    };

    useEffect(() => {
        new Promise(async (resolve, reject) => {
            return Promise.resolve();
        });
    }, []);

    return (
        <>
            {/* <div className='d-flex justify-content-center'> */}
            <HomeHeader linker={props.linker}></HomeHeader>
            {/* </div> */}
        </>
    );
};

export default Home;